import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { nameReducer } from '../Features.model';
import StoreProvider from '../../../shared/Storage';

const THEME_STORAGE_KEY = 'features_theme';

/** Build a fresh initial state, reading persisted values from StoreProvider. */
const getInitialState = (): FeaturesState => ({
  theme: StoreProvider.getItem<string>(THEME_STORAGE_KEY) ?? 'light',
  OPERATOR_DEVICE_SIMPLE_VIEW: 'HORIZONTAL',
  filters: {},
});

export const initialStateFeatures: FeaturesState = getInitialState();

export interface FeaturesState {
  theme: string;
  OPERATOR_DEVICE_SIMPLE_VIEW: 'HORIZONTAL' | 'VERTICAL';
  filters: Record<string, any>;
}

export const FeaturesSlice = createSlice({
  name: nameReducer,
  initialState: getInitialState,
  reducers: {
    changeFeaturesTheme: (state, action: PayloadAction<string>) => {
      state.theme = action.payload;
      StoreProvider.setItem(THEME_STORAGE_KEY, action.payload);
    },
    toggleOperatorView: (state) => {
      state.OPERATOR_DEVICE_SIMPLE_VIEW =
        state.OPERATOR_DEVICE_SIMPLE_VIEW === 'HORIZONTAL'
          ? 'VERTICAL'
          : 'HORIZONTAL';
    },
    updateFilter(state, action: PayloadAction<{ path: string; filter: any }>) {
      const { path, filter } = action.payload;
      state.filters[path] = filter;
    },
  },
});

export const {
  actions: FeaturesActions,
  reducer: FeaturesReducer,
  name: FeaturesNameReducer,
} = FeaturesSlice;
